// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"613":"cfbda66e","638":"ba234e29","654":"3cc86fa3","810":"6708d860"}[chunkId] + ".css";
};